module.exports = __webpack_public_path__ + "img/DISPTCHD.a9577bf3.svg";